import ApiRequest from './ApiRequest';

class CategoriesApi extends ApiRequest {
  getCategories() {
    return this.get('categories')
      .then(response => response.data)
      .catch(error => console.log(error)); // eslint-disable-line no-console
  }
}

export default CategoriesApi;



// WEBPACK FOOTER //
// ./src/api/CategoriesApi.js